import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { CommonModule } from '@angular/common';
import { AppInputComponent, InputType } from 'src/app/shared/components/app-input/app-input.component';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AppSelectInputComponent, SelectModel } from 'src/app/shared/components/app-select-input/app-select-input.component';
import { AppInputCustomComponent, InputMaskTypes } from 'src/app/shared/components/app-input-custom/app-input-custom.component';
import { AppCheckboxComponent } from 'src/app/shared/components/app-checkbox/app-checkbox.component';
import { AppButtonComponent } from 'src/app/shared/components/app-button/app-button.component';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { UserService } from 'src/app/core/services/user.service';
import { CommonService } from 'src/app/core/services/common.service';
import { MemberService } from 'src/app/core/services/member.service';
import { UserModel } from 'src/app/shared/models/userModel';
import { CepService } from 'src/app/core/services/cep.service';
import { ReplaceTextPipe } from "../../shared/pipe/replace-text.pipe";

@Component({
  selector: 'app-dados-de-socio',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AppInputComponent,
    AppInputCustomComponent,
    AppSelectInputComponent,
    AppCheckboxComponent,
    AppButtonComponent,
    ReplaceTextPipe
  ],
  templateUrl: './dados-de-socio.component.html',
  styleUrls: ['./dados-de-socio.component.scss']
})
export class DadosDeSocioComponent implements OnInit, OnDestroy {
  private _destroy$ = new Subject<void>();

  InputTypeEnum = InputType;
  InputMaskTypesEnum = InputMaskTypes;

  // TODO: Rever estrutura de color
  labelColor = 'white';

  isForeigner: boolean = false;
  isForeignerAdress: boolean = false;

  buttonOptions = {
    buttonText: 'Voltar',
    buttonSize: 'btn btn-md px-3 btn-secondary',
    borderRadius: '25px'
  };

  submitBtn = {
    buttonText: 'Salvar',
    borderRadius: '25px',
    buttonSize: 'btn btn-sm px-4 btn-primary',
    btnDisabledBackground: '#f2e2b2',
    btnDisabledTextColor: '#000000'
  };

  partnerDataformGroup = new FormGroup({
    name: new FormControl<string>('', Validators.required),
    loginControl: new FormControl<string>({ value: '', disabled: true }, Validators.required),
    birthDate: new FormControl<string>({ value: '', disabled: true }, Validators.required),
    genderControl: new FormControl<string>('', Validators.required),
    emailControl: new FormControl<string>('', [Validators.required, Validators.email]),
    phoneControl: new FormControl<string>(''),
    CEPControl: new FormControl<string>('', Validators.required),
    addressControl: new FormControl<string>('', Validators.required),
    numberControl: new FormControl<number>(0, Validators.required),
    complementControl: new FormControl<string>(''),
    neighborhoodControl: new FormControl<string>('', Validators.required),
    stateControl: new FormControl<string>('', Validators.required),
    cityControl: new FormControl<string>('', Validators.required),
    rankingConfirmarionControl: new FormControl<boolean>(false),
    isForeigner: new FormControl<boolean>(false),
    countryControl: new FormControl<any>('', Validators.required),
    countryAdressControl: new FormControl<any>('', Validators.required),
  });

  protected genderOptions = [
    { code: 'M', name: 'Masculino' },
    { code: 'F', name: 'Feminino' },
    { code: 'NI', name: 'Não informado' }
  ] as SelectModel[];

  protected countriesList = [] as SelectModel[];

  protected stateOptions = [] as SelectModel[];

  protected cityOptions = [] as SelectModel[];
  user: UserModel;

  constructor(
    private router: Router,
    private location: Location,
    private userService: UserService,
    private commonService: CommonService,
    private memberService: MemberService,
    private cepService: CepService
  ) {
    this.user = this.userService.currentUserValue as UserModel;
  }

  partner: any = null;
  addressId: any = null;

  ngOnInit(): void {
    this.commonService.getStatePublic().subscribe(states => {
      this.stateOptions = states.map((obj: any) => ({ code: obj.id, name: obj.name }));
      this.loadMemberData();
    });

    this.commonService.getCountries().subscribe((res: any) => {
      this.countriesList = res.map((city: any) => {
        return {
          code: city.id,
          name: city.name
        } as SelectModel;
      });
    });

    this.partnerDataformGroup.get('isForeigner')?.disable();

    this.verifyCountry();
  }

  getAddressByCEP(): void {
    const cep = this.partnerDataformGroup.get('CEPControl')?.value as string;
    if (cep.length === 8) {
      this.cepService.searchCep(Number(cep)).subscribe((response) => {
        this.partnerDataformGroup.get('CEPControl')?.setValue(response.cep);
        this.partnerDataformGroup.get('addressControl')?.setValue(response.logradouro);
        this.partnerDataformGroup.get('neighborhoodControl')?.setValue(response.bairro);
        this.partnerDataformGroup.get('stateControl')?.setValue(
          this.stateOptions.find((state) => state.name === response.estado)?.code as string
        );


        this.commonService.getCity(this.partnerDataformGroup.get('stateControl')?.value).subscribe((cityResponse) => {
          this.cityOptions = cityResponse.map((city: any) => ({
            code: city.id,
            name: city.name,
          }));

          const city = this.cityOptions.find((c: any) => c.code === Number(response.ibge))?.code;
          if (city) {
            this.partnerDataformGroup.get('cityControl')?.setValue(city);
          }
        });
      });
    }
  }


  private loadMemberData(): void {
    this.memberService.getMemberDashboardData(this.user.id).subscribe(res => {
      this.partner = res;
      this.isForeigner = res.isForeigner;
      this.isForeignerAdress = res.addresses?.length > 0 && res.addresses[0]?.country?.id !== null && res.addresses[0]?.country?.id != 1;
      this.populateForm();
    });
  }

  private populateForm(): void {
    if (this.partner) {
      const address = this.partner.addresses[0];
      const email = this.partner.emails.find((e: any) => e.isPrincipal);
      const phone = this.partner.phones.find((p: any) => p.isPrincipal);

      this.partnerDataformGroup.patchValue({
        name: this.partner.name,
        loginControl: this.partner.cpf,
        birthDate: this.partner.birthDate
          ? this.partner.birthDate.split('-').reverse().join('/')
          : '', // Define como string vazia se for null ou undefined
        genderControl: this.partner.gender,
        emailControl: email?.email,
        phoneControl: phone?.number,
        CEPControl: address?.zipCode,
        addressControl: address?.area,
        numberControl: address?.number,
        complementControl: address?.complement,
        neighborhoodControl: address?.neighborhood,
        stateControl: address?.stateCode,
        cityControl: address?.cityCode,
        rankingConfirmarionControl: this.partner.participatesInRanking,
        isForeigner: this.partner.isForeigner,
        countryControl: this.partner?.country?.id || 1,
        countryAdressControl: address?.country?.id || 1
      });

      if (address?.stateCode) {
        this.getCities();
      }

      // Verifique se birthDateControl não é null antes de chamar enable() ou disable()
      const birthDateControl = this.partnerDataformGroup.get('birthDate');
      if (birthDateControl) {
        if (birthDateControl.value) {
          birthDateControl.disable();
        } else {
          birthDateControl.enable();
        }
      }

      if (phone?.number) {
        this.partnerDataformGroup.get('phoneControl')?.addValidators(Validators.required);
      } else {
        this.partnerDataformGroup.get('phoneControl')?.removeValidators(Validators.required);
      }
      this.partnerDataformGroup.get('phoneControl')?.updateValueAndValidity();

      this.verifyCountry();
    }
  }

  back() {
    this.location.back();
  }


  verifyCountry() {
    const country = this.partnerDataformGroup.get('countryAdressControl')?.value;

    if (country !== null && country != 1) {
      this.isForeignerAdress = true;
      this.partnerDataformGroup.get('cityControl')?.setValidators(null);
      this.partnerDataformGroup.get('stateControl')?.setValidators(null);
      this.partnerDataformGroup.get('neighborhoodControl')?.setValidators(null);
      this.partnerDataformGroup.get('numberControl')?.setValidators(null);
      this.partnerDataformGroup.get('CEPControl')?.setValidators(null);
      this.partnerDataformGroup.get('cityControl')?.updateValueAndValidity();
      this.partnerDataformGroup.get('stateControl')?.updateValueAndValidity();
      this.partnerDataformGroup.get('neighborhoodControl')?.updateValueAndValidity();
      this.partnerDataformGroup.get('numberControl')?.updateValueAndValidity();
      this.partnerDataformGroup.get('CEPControl')?.updateValueAndValidity();
    } else {
      this.isForeignerAdress = false;
      this.partnerDataformGroup.get('cityControl')?.setValidators(Validators.required);
      this.partnerDataformGroup.get('stateControl')?.setValidators(Validators.required);
      this.partnerDataformGroup.get('neighborhoodControl')?.setValidators(Validators.required);
      this.partnerDataformGroup.get('numberControl')?.setValidators(Validators.required);
      this.partnerDataformGroup.get('CEPControl')?.setValidators(Validators.required);
      this.partnerDataformGroup.get('cityControl')?.updateValueAndValidity();
      this.partnerDataformGroup.get('stateControl')?.updateValueAndValidity();
      this.partnerDataformGroup.get('neighborhoodControl')?.updateValueAndValidity();
      this.partnerDataformGroup.get('numberControl')?.updateValueAndValidity();
      this.partnerDataformGroup.get('CEPControl')?.updateValueAndValidity();
    }

    this.partnerDataformGroup.updateValueAndValidity();
  }


  onSubmit(): void {
    if (this.partnerDataformGroup.valid) {
      const partnerData = this.buildPayloadPartnerData(this.partnerDataformGroup);
      this.memberService.update(partnerData, this.partner.id).subscribe({
        next: () => {
          this.saveAddress();
        }
      });
    } else {
      console.log('Form is invalid');
    }
  }

  public saveAddress() {
    const data = this.buildPayloadPartnerDataAddress(this.partnerDataformGroup);

    // Verifica se há informações relevantes no endereço
    const hasAddressData = data.zipCode || data.area || data.number || data.neighborhood || data.stateCode || data.cityCode;

    if (!hasAddressData) {
      this.getMemberUpdated();
      return;
    }

    if (data?.id) {
      this.memberService.updateAddress(this.partner?.addresses[0]?.id, data).subscribe({
        next: () => {
          this.getMemberUpdated();
        },
        error: (err) => {
          console.error('Erro ao atualizar endereço:', err);
        }
      });
    } else {
      this.memberService.postMemberAddress(data).subscribe({
        next: () => {
          this.getMemberUpdated();
        },
        error: (err) => {
          console.error('Erro ao criar endereço:', err);
        }
      });
    }
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public getMemberUpdated() {
    this.memberService.getMemberPublicInfo().pipe(takeUntil(this._destroy$)).subscribe(item => {
      this.router.navigate(['/dashboard']);
    });
  }

  private buildPayloadPartnerData(formGroup: FormGroup): any {
    const email = this.partner?.emails.find((email: any) => email.isPrincipal);
    const phone = this.partner?.phones.find((email: any) => email.isPrincipal);

    return {
      name: formGroup.get('name')?.value,
      cpf: formGroup.get('loginControl')?.value,
      birthDate: formGroup.get('birthDate')?.value.split('/').reverse().join('-'),
      gender: formGroup.get('genderControl')?.value,
      participatesInRanking: formGroup.get('rankingConfirmarionControl')?.value,
      phones: [{
        id: phone?.id || null, description: null, isPrincipal: true, isActive: true,
        isDeleted: false, number: formGroup.get('phoneControl')?.value,
        createdAt: phone?.createdAt || null, updatedAt: phone?.updatedAt || null
      }],
      emails: [{
        id: email?.id || null, description: null, isPrincipal: true, isActive: true,
        isDeleted: false, email: formGroup.get('emailControl')?.value.toLowerCase(),
        createdAt: email?.createdAt || null, updatedAt: email?.updatedAt || null
      }]
    };
  }

  private buildPayloadPartnerDataAddress(formGroup: FormGroup): any {
    return {
      id: this?.partner?.addresses[0]?.id || null,
      zipCode: formGroup.get('CEPControl')?.value,
      area: formGroup.get('addressControl')?.value,
      number: formGroup.get('numberControl')?.value,
      complement: formGroup.get('complementControl')?.value,
      neighborhood: formGroup.get('neighborhoodControl')?.value,
      stateCode: formGroup.get('stateControl')?.value,
      cityCode: formGroup.get('cityControl')?.value,
      memberId: this.user.id,
      country: { id: formGroup.get('countryAdressControl')?.value }
    };
  }

  getCities() {
    let state = this.partnerDataformGroup.value.stateControl;
    if (state) {
      this.commonService.getCity(state).subscribe(cities => {
        this.cityOptions = cities.map((obj: any) => ({ code: obj.id, name: obj.name }));
      });
    }
  }
}
